import * as React from 'react';
import { useCallback, useMemo, useContext } from 'react';
import classNames from 'classnames';
import styled from 'styled-components';
import _ from 'lodash';

import { getColor } from '@/lib/get-color';
import { AccountLink, AppNavigatorParamsContext, AppNavigatorPathContext } from '@/lib/navigation';

export interface TagProps {
  name: string;
  color?: string;
  external: boolean;
  handleRemove?: (name: string) => void;
  search?: string;
  searchSubdomain?: string;
  searchExact?: boolean; // whether to search for exact tag match or substring
}

const TagContainer = styled.div<{ color: string }>`
  background: ${({ color }) => color};
`;

export const Tag = ({
  name, color, external, handleRemove, search, searchSubdomain, searchExact = true,
}: TagProps) => {
  const path = useContext(AppNavigatorPathContext);
  const params = useContext(AppNavigatorParamsContext);

  const handlePress = useCallback(() => handleRemove(name), [name, handleRemove]);

  const isSearchPath = _.last(path.asList) === search;
  const searchParams = useMemo(
    () => ({ ...(isSearchPath && params), search: `${searchExact ? 'tag' : 'tags'}: "${name}"` }),
    [name, isSearchPath, params],
  );
  const setColor = !color ? getColor(name) : color;

  return (
    <div className="tag-wrapper">
      <TagContainer title={name} className={classNames('tag', !external && 'internal')} color={setColor}>
        {search
          ? (
            <AccountLink
              subdomain={searchSubdomain}
              path={search}
              params={searchParams}
              className="tag-text"
              label={name}
            />
          ) : <button type="button" className="tag-text">{name}</button>}
        {handleRemove && <button type="button" className="remover" onClick={handlePress} onKeyPress={handlePress}>X</button>}
      </TagContainer>
    </div>
  );
};
